<template lang="html">

  <section class="payments">
    <div class="pageHeading">
        <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex >
                    <h2>Payments</h2>
                </v-flex>
                <v-flex  xs12 md6>

                    <v-autocomplete v-show="!$isParent"
                            v-model="$filterTripID"
                            :items="$structuredData.trips"
                            @change="selectedResult = null"
                            color="black"
                            hide-no-data
                            hide-selected
                            item-text="prettyName"
                            item-value="_id"
                            label="Limit To Trip ID"
                            persistent-hint
                            solo
                            prepend-icon="mdi-database-search"
                            return-object
                    ></v-autocomplete>
                </v-flex>
            </v-layout>
        </v-container>
    </div>

      <v-container   v-if="$userData.permissions.includes('admin') || $userData.permissions.includes('sales')">




          <v-toolbar
                  color="primary"
                  dark
                  tabs
          >
              <v-text-field
                      class="mx-3"
                      flat
                      v-model="search"
                      label="Search billing name, trans ref, amount"
                      prepend-inner-icon="search"
                      clearable
                      solo-inverted
              ></v-text-field>

          </v-toolbar>


          <v-data-table :headers="headers" :items="payments" :search="search"
          >
              <template slot="items" slot-scope="props">
                  <tr>
                      <td>{{ props.item.BillingName }}</td>
                      <td class="text-xs-left">{{ props.item.Type }}</td>
                      <td class="text-xs-left">{{ props.item.ParticipantName }}</td>
          
                      <td class="text-xs-left">{{ props.item.Status }}</td>
                      <td class="text-xs-left">{{ props.item.Amount }}</td>
                      <td class="text-xs-left">{{ props.item.TransRef }}</td>
                      <td><a target="_blank" :href="props.item.invoicePath">Download</a></td>
                      <td class="text-xs-left">{{ props.item.Date  | moment("MM/DD/YYYY")}}</td>
                      <td>
                          <v-btn small dark :color="limitToUser == null ? 'secondary': 'primary'"
                                 @click="addPayingUserFilter(props.item.PayingUser)">User</v-btn>
                          <v-btn :color="limitToParticipant == null ? 'secondary': 'primary'"
                                 @click="addParticipantFilter(props.item.Participants[0].ParticipantID)" small dark>Participant</v-btn>
                      </td>

                  </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ search }}" found no results.
              </v-alert>
          </v-data-table>
      </v-container>

    <v-container v-else >

      <v-layout row v-for="participant in $structuredData.participants">
        <v-flex xs12 >
    <v-card >
      <v-card-title primary-title style="background-color: #a5a2a2">
        <v-flex>
          <h3 class="headline mb-0">{{participant.firstName + ' ' + participant.middleName + ' ' +participant.lastName}}</h3>
        </v-flex>
      </v-card-title>



      <p class="pa-2" v-if="participant.Payments.length == 0">No payment activity</p>


      <v-layout style="border-bottom: 1px grey solid; padding: 5px 0px" row wrap v-for="payment in participant.Payments">


        <v-flex xs3 md3 >
          <span class="topTextBottomLabels">****{{payment.Last4}}</span>
          <br/>
          <strong class="bottomLabelsNoUnderline">{{payment.Type}}</strong>

        </v-flex>

        <v-flex xs3 md3 >
          <span class="topTextBottomLabels">{{payment.BillingName}}</span>
          <br/>
          <strong class="bottomLabelsNoUnderline">Billing Name</strong>

        </v-flex>

        <v-flex xs3 md3 >
          <span class="topTextBottomLabels">${{payment.Amount}}</span>
          <br/>
          <strong class="bottomLabelsNoUnderline">Amount</strong>

        </v-flex>

        <v-flex xs3 md3 >
          <span class="topTextBottomLabels">{{payment.Status}}</span>
          <br/>
          <strong class="bottomLabelsNoUnderline">{{payment.Date | moment("MM/DD/YYYY")}}</strong>

        </v-flex>

      </v-layout>


    </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script lang="js">
  export default  {
    name: 'payments',
    props: [],
    mounted() {

    },
    data() {
      return {
          search: '',
          limitToParticipant: null,
          limitToUser: null,
          headers: [
              {
                  text: 'Billing Name',
                  align: 'left',
                  sortable: false,
                  value: 'BillingName',
              },
              { text: 'Type',
                  align: 'left',
                  sortable: true,
                  value: 'Type' },
            {
              text: 'Participant Name',
              align: 'left',
              sortable: false,
              value: 'ParticipantName',
            },
              { text: 'Status',
                  align: 'left',
                  sortable: true,
                  value: 'Status' },

              { text: 'Amount',
                  align: 'left',
                  sortable: true,
                  value: 'Amount' },

              { text: 'TransRef',
                  align: 'left',
                  sortable: false,
                  value: 'TransRef' },
              { text: 'Invoice',
                  align: 'left',
                  sortable: false,
                  value: 'invoicePath' },

              { text: 'Date',
                  align: 'left',
                  sortable: true,
                  value: 'Date' },
              {
                  text: 'Limit Results',
              }
          ]
      }
    },
      components: {
      },
    methods: {
        addPayingUserFilter(id) {
            this.limitToParticipant = null;
            if(this.limitToUser != id)
                this.limitToUser = id;
            else
                this.limitToUser = null
        },
        addParticipantFilter(id) {
            this.limitToUser = null;
            if(this.limitToParticipant != id)
                this.limitToParticipant = id;
            else
                this.limitToParticipant = null
        },

    },
    computed: {
        payments() {
            var toReturn = []
            console.log('the data is', this.$structuredData)
            if(this.limitToParticipant == this.limitToUser){
                return this.$structuredData.payments
            } else {
                this.$structuredData.payments.forEach((payment) => {
                    console.log('checking payment', payment)
                    if((this.limitToUser != null && payment.PayingUser == this.limitToUser) ||
                        (this.limitToParticipant != null && payment.Participants[0].ParticipantID == this.limitToParticipant)) {
                        if(this.search.trim() == '') {
                            toReturn.push(payment);
                        } else if(payment.BillingName.toLowerCase().contains(this.search) ||
                            payment.Amount == this.search ||
                            payment.TransRef.toLowerCase().contains(this.search)) {
                            toReturn.push(payment);
                        }
                    }
                })
                return toReturn
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .payments {

  }
</style>
